import { render, staticRenderFns } from "./ExcelUploader.vue?vue&type=template&id=9b2b5cbe&scoped=true&"
import script from "./ExcelUploader.vue?vue&type=script&lang=js&"
export * from "./ExcelUploader.vue?vue&type=script&lang=js&"
import style0 from "./ExcelUploader.vue?vue&type=style&index=0&id=9b2b5cbe&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b2b5cbe",
  null
  
)

export default component.exports